import { useCallback, useRef } from "react";
import { track } from "@visioni/a3s-analytics";
import { AlarmOverrideEdited, AlarmOverrideOpened } from "@src/features/alarms/analytics";
import { cameraScope } from "@src/features/cameras/analytics";
import type { OverrideMode } from "@src/features/cameras/hooks/useAlarmOverridePanelState";

/** Opened on each open of the arm/disarm panel; Edited once per open, on the first change. */
export function useOverrideAnalytics(tenantId: string, siteId: string | undefined, cameraKey: string | undefined) {
  const openMode = useRef<OverrideMode>("override");
  const edited = useRef(false);

  const trackOpened = useCallback(
    (mode: OverrideMode) => {
      openMode.current = mode;
      edited.current = false;
      track(AlarmOverrideOpened, { ...cameraScope(tenantId, siteId, cameraKey), mode });
    },
    [tenantId, siteId, cameraKey],
  );

  const trackEdited = useCallback(() => {
    if (edited.current) return;
    edited.current = true;
    track(AlarmOverrideEdited, { ...cameraScope(tenantId, siteId, cameraKey), mode: openMode.current });
  }, [tenantId, siteId, cameraKey]);

  return { trackOpened, trackEdited };
}
